import React from 'react';
import TableReport from '@componentes/TableReport';
import Table from './Table';
import IntlMessage from "../../../../helpers/intlMessage";

function ImpressaoImuno ({ lista }) {
  return (
    <TableReport
      title={<IntlMessage id = "dashboards.reports.antigenRequisitionReport"/>}
      assinatura={<IntlMessage id = "dashboards.reports.subscriptionCRM"/>}
    >
      {lista.map((item, i) => (
        <tr
          key={i}
          style={{ border: 0 }}
          className='relatorio-controle-tarefa-imuno'
        >
          <td style={{ border: 0, padding: 0 }}>
            <Table item={item} />
          </td>
        </tr>
      ))}
    </TableReport>
  );
}

export default ImpressaoImuno;



// WEBPACK FOOTER //
// ./src/pages/controleTarefas/Imuno/Impressao/index.js